<!-- app-glm-materias-card -->
<mat-card appearance="outline" class="dashboard-card" *ngIf="materias.length > 0">
  <mat-card-header>
    <mat-card-title>
      <div *ngIf="propio" i18n="@@misMaterias">Mis materias</div>
      <div *ngIf="!propio" i18n="@@materias">Materias</div>
    </mat-card-title>
  </mat-card-header>

  <mat-card-content style="margin-top: 8px;">
    <mat-accordion class="materias-list" [multi]="false">
      <ng-container *ngFor="let materia of materias">
        <!-- Cada hijo ahora pinta su propio mat-expansion-panel -->
        <app-materia-card 
          [materia]="materia"
          (detalleOpen)="emitDetalle($event)"
          [hijo]="hijo">
        </app-materia-card>
      </ng-container>
    </mat-accordion>
  </mat-card-content>
</mat-card>
